<template>
    <v-btn class="disable-button-active" color="primary" depressed :to="{ name: 'AuthLogin'}" exact v-if="!loggedIn">
        Login
        <v-icon>mdi-login</v-icon>
    </v-btn>

    <v-menu open-on-hover offset-y left v-else>
        <template v-slot:activator="{ on, attrs}">
            <v-btn outlined rounded color="primary" class="mr-2" v-bind="attrs" v-on="on">
                {{user.first_name}} {{user.last_name}}
                <v-icon>mdi-account</v-icon>
            </v-btn>
        </template>

        <v-list dense
                nav>
            <v-list-item link :to="{ name: 'UserProfile'}">
                <v-list-item-icon>
                    <v-icon>mdi-account-box</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Profil</v-list-item-title>
            </v-list-item>
            <v-divider/>
            <v-list-item link @click="logout">
                <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>

</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "app-layout-navbar-profile",
        data: () => ({
        }),

        created(){
            this.checkUserState();
        },
        mounted() {
        },
        computed: {
            loggedIn() {
                return this.$store.getters['user/loggedIn'];
            },
            user(){
                return this.$store.getters['user/userDetails'];
            }
        },
        methods: {
            ...mapActions({
                checkUserState: 'user/setLoggedInState'
            }),
            logout(){
                this.$store.dispatch('user/logoutUser')
                    .then(() => {
                        this.$router.push({name: 'AuthLogin'});
                    })
            }
        }
    }
</script>

<style scoped>

</style>